module.exports = __webpack_public_path__ + "img/equatorial-guinea.78c876ee.png";